// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.PromoRowWidget = ( function()
{
    "use strict";

    PromoRowWidget.prototype = new CollectionRowWidget();

    function PromoRowWidget(){}

    PromoRowWidget.prototype.init = function( params )
    {
        params.type = PromoCellWidget;
        params.y    = _x2.scaleVal( 152 ) - _x2.scaleVal( 13 );
        params.h    = _x2.scaleValInt( 398 );

        CollectionRowWidget.prototype.init.call( this, params );
        this._className  = "PromoRowWidget";

        return this;
    };

    PromoRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 600 );
    };

    return PromoRowWidget;

})();
